<template>
  <div
    v-if="ProjectInfo"
    class="d-flex flex-column flex-grow-1 justify-content-around section-container"
    :class="{ dark: skinType }"
    style="padding: 1rem 2rem 1rem 4rem"
  >
    <div class="d-flex align-items-stretch">
      <div class="company-info none-width flex-grow-1">
        <span class="iconfont icongaiicon-"></span>项目名称：<span
          class="decText"
          >{{ ProjectInfo.ProjectName }}</span
        >
      </div>
      <div class="company-info none-width flex-grow-1">
        <span class="iconfont iconarea2"></span>
        建筑面积：<span class="decText">{{ ProjectInfo.ProjectArea }}㎡</span>
      </div>
    </div>
    <div class="d-flex">
      <div class="company-info none-width flex-grow-1">
        <span class="iconfont iconzongrongliang"></span>
        总容量：<span class="decText">{{ ProjectInfo.RiongLiang }}kVA</span>
      </div>
      <div class="company-info none-width flex-grow-1">
        <span class="iconfont icondianhua"></span>
        用户类别：<span class="decText">{{ProjectInfo.ProjectUserType}}</span>
      </div>
    </div>
    <div class="company-info align-items-center">
      <span class="iconfont icondizhi-2"></span>
      地址：<span class="decText">{{ ProjectInfo.Address + '。   联系电话：'+ ProjectInfo.Tel}}
          </span>       <!-- 在这个后面加联系电话： -->
    </div>
  </div>
  <no-data-temporarily
    v-else
    style="width: 100%; height: 100%"
  ></no-data-temporarily>
</template>

<script>
import { ele1 } from '@/api/ele-situation/ele1';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import TurnAskingMixin from '@/mixins/turn-ask';

export default {
  mixins: [TurnAskingMixin],
  data() {
    return {
      ProjectInfo: null,
    };
  },
  props: {
    proId: {
      type: String,
    },
  },
  components: {
    NoDataTemporarily,
  },
  watch: {
    proId(a) {
      this.requestData(a);
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    requestData(a) {
      ele1({
        ProjectIdStr: a,
      })
        .then((res) => {
          [this.ProjectInfo] = res.Project;
        })
        .catch(() => {
          this.ProjectInfo = null;
        })
        .then(() => {
          this.turnAsking({
            routeName: this.routeName,
            nowRouteName: this.$route.name,
            func: () => {
              this.requestData(a);
            },
          });
        });
    },
  },
};
</script>
<style scoped>
.iconfont {
  font-size: 1.4rem;
  margin-right: 2%;
  color: #5b93ff;
}
.company-info {
  font-size: 1rem;
  display: flex;
  align-items: flex-end;
  flex-direction: row;
  flex-wrap: wrap;
}
.smalldiv {
  width: 100%;
  display: flex;
  flex-direction: column;
  /* background: chartreuse; */
  justify-content: space-between;
}
.decText {
  font-size: 1rem;
  word-break: break-all;
  word-wrap: wrap;

  /* font-weight: 550; */
}
</style>
